import { render, staticRenderFns } from "./message-media-preview.vue?vue&type=template&id=3f78b422&scoped=true&"
import script from "./message-media-preview.vue?vue&type=script&lang=js&"
export * from "./message-media-preview.vue?vue&type=script&lang=js&"
import style0 from "./message-media-preview.vue?vue&type=style&index=0&id=3f78b422&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f78b422",
  null
  
)

export default component.exports